<div class="app-container">
    @if (!environment.production) {
        <div
            class="environment-label"
            [style.left.px]="dragPosition.x"
            [style.top.px]="dragPosition.y"
            [class.dragging]="isDragging">
            <div
                class="drag-handle"
                (mousedown)="onDragStart($event)"
                (touchstart)="onTouchStart($event)"
                title="Drag to move">
                ⋮⋮
            </div>
            <div ngbDropdown>
                <button
                    ngbDropdownToggle
                    sfButton
                    size="sm"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false">
                    {{ environment.environmentName || 'DEV' }}
                </button>
                <ul ngbDropdownMenu>
                    @for (env of environmentOptions; track env.name) {
                        <li>
                            <a ngbDropdownItem href="#" (click)="switchEnvironment(env.url); $event.preventDefault()">
                                {{ env.name }}
                            </a>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }

    <sf-sidebar-starter id="sidebar1">
        <sf-sidebar-starter-user-icon
            [user]="me()"
            [companySettings]="companySettings()"
            (requestChangePassword)="requestChangePassword()"
            (logout)="logout()"></sf-sidebar-starter-user-icon>

        <sf-sidebar-starter-nav></sf-sidebar-starter-nav>
        <sf-sidebar-starter-footer (logout)="logout()">
            <sf-sidebar-starter-nav></sf-sidebar-starter-nav> </sf-sidebar-starter-footer
    ></sf-sidebar-starter>
    <sf-sidebar #sidebar1="sfSidebar" id="sidebar1" visible>
        <sf-sidebar-header>
            <sf-sidebar-brand [routerLink]="['/dashboard']">
                <img src="assets/images/surefire-logo.svg" alt="Logo" class="img-fluid" style="height: 30px" />
            </sf-sidebar-brand>
        </sf-sidebar-header>
        <sf-sidebar-nav [navItems]="filteredNavItems" dropdownMode="path" compact></sf-sidebar-nav>
        @if (me(); as me) {
            @if (me.subscription.onTrial && me.subscription.paymentDetailsRequired) {
                <sf-sidebar-footer>
                    <sf-sidebar-trial
                        [onTrial]="me.subscription.onTrial"
                        [trialDaysLeft]="me.subscription.trialDaysLeft"></sf-sidebar-trial>
                </sf-sidebar-footer>
            }
        }
    </sf-sidebar>

    <div class="wrapper d-flex flex-column min-vh-100">
        <sf-header (menuToggle)="toggleMenu()" sidebarId="sidebar1"></sf-header>
        <div class="container-fluid px-2 px-sm-3 px-xl-4">
            @if (me()?.isImpersonating) {
                <div class="my-3 p-3 bg-danger bg-opacity-10">
                    <div class="d-grid">
                        <button
                            sfButton
                            type="button"
                            color="danger"
                            [disabled]="stoppedImpersonationClicked()"
                            (click)="stopImpersonation()">
                            Stop Impersonating
                        </button>
                    </div>
                </div>
            }
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<!-- <div>Test</div>
            <div *ngxPermissionsOnly="'DiaryManagement'">Diary Management</div>
            <div *ngxPermissionsOnly="'tester'">Doesn't exist</div>
            <div *ngxPermissionsOnly="'ADMIN'">Admin Role</div>
            <div *ngxPermissionsOnly="'SUPPORT'">Support Role</div>
            <div *ngxPermissionsOnly="'Fake'">Fake Role</div> -->

<!-- <div
    class="app-container"
    [class.sidebar-hidden]="!appStore.isSidebarVisible()" 
    [class.sidebar-open]="appStore.isSidebarVisible()">
    <sf-header (menuToggle)="toggleMenu()"></sf-header>

    <nav class="app-sidebar">
        <div class="app-header__logo">
            <div class="logo-src">
                <img src="/assets/images/surefire-logo.svg" alt="Surefire Software" class="img-fluid" />
            </div>
            <button class="main-menu-button ms-auto p-3" (click)="toggleMenu()">
                <fa-icon [icon]="['fas', 'bars']"></fa-icon>
            </button>
        </div>
        <sf-side-menu
            [postCounter]="appStore.postCounter()"
            [unreadNoticesCount]="appStore.unreadNoticesCount()"
            (showSidebar)="$event ? appStore.showSidebar() : appStore.hideSidebar()"></sf-side-menu>
    </nav> 
    <div class="app-main__outer">
        <div class="app-main__wrapper">
            @if (title) {
                <div class="main-title align-items-center d-flex justify-content-between">
                    <div class="main-title__heading">{{ title }}</div>
                </div>
            }

            <div class="app-main__inner">
                @if (me()?.firstLogin === null) {
                    <sf-callout color="danger">
                        <h5>Change Password</h5>
                        <p class="mb-0">
                            You are required to change your password.<br /><a routerLink="/account/change-password"
                                >Click here to change your password now</a
                            >.
                        </p>
                    </sf-callout>
                } -->
<!-- <button sfButton (click)="testClick()">Test</button> -->

<!-- <router-outlet></router-outlet> -->

<!-- <sf-callout class="mt-3" icon="question-circle">
                    <h5>Need Help?</h5>
                    <p class="mb-0">
                        If you have any questions or need support click <a routerLink="/help/contact-support">here</a>.
                    </p>
                </sf-callout> -->
<!-- </div>
        </div>
    </div> -->

<!-- @if (authService.user$ | async; as user) { -->
<!-- <div *ngxPermissionsOnly="'SUPPORT'" class="app-info">
            <div class="app-info__content">
                <div class="app-info__item"><b>Environment:</b> {{ user.environment }}</div>
                <div class="app-info__item"><b>Company Id:</b> {{ user.companyId }}</div>
            </div>
        </div> -->
<!-- } -->
<!-- </div> -->

<!-- Onboarding Checklist -->
@if (!onboardingService.isOnboardingDismissed()) {
    <ng-container *ngxPermissionsOnly="'ADMIN'">
        <sf-onboarding-checklist></sf-onboarding-checklist>
    </ng-container>
}

<sf-loading-spinner [isLoading]="appStore.isLoading()"></sf-loading-spinner>
